import i18n from 'i18next';

// const API_ENDPOINT = 'http://local.golfamore-api/v3/web-sales/';
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://local.golfamore-api/v3/web-sales/';
// const API_ENDPOINT = 'https://dev.golfamore.com/v3/web-sales/';

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const defaultErrorMessages = {
  'The user aborted a request.': 'The request took too long, please try again'
};

const request = async (method, resource, body) => {
  const controller = new AbortController();
  const { signal } = controller;

  const timeout = setTimeout(() => {
    controller.abort();
  }, 20000);

  const url = `${API_ENDPOINT}${resource}?language=${i18n.language}`;

  const config = {
    method,
    headers: defaultHeaders,
    signal
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, config);

    if (response.ok) {
      return await handleOKResponse(response);
    }

    return await handleFailedRequest(response);
  } catch (error) {
    return handleNetworkError(error);
  } finally {
    clearTimeout(timeout);
  }
};

const handleOKResponse = async (response) => {
  const isSuccess = response.status === 200;

  try {
    const responseData = await response.json();

    if (isSuccess) {
      return { response: responseData, error: null };
    }

    return { response: null, error: responseData?.message || 'Unknown error (Error message missing)' };
  } catch (err) {
    return { response: null, error: err?.message || 'Unknown error (Json parse failed)' };
  }
};

const handleFailedRequest = async (response) => {
  if (response.status === 500) {
    return { error: 'We have encountered an internal error, please contact Golfamore for assistance' };
  }

  if (response.status === 404) {
    return { error: 'Authentication failed, please check your credentials' };
  }

  try {
    const responseData = await response.json();
    return { error: responseData?.message || `Unknown error (${response.status})` };
  } catch (err) {
    return { error: `Unknown error (${response.status})` };
  }
};

const handleNetworkError = (error) => {
  const errorMessage = defaultErrorMessages[error.message] || error.message || 'Unknown error (Network error)';
  return { response: null, error: errorMessage };
};

export const get = (url) => request('get', url);
export const post = (url, body) => request('post', url, body);
export const put = (url, body = null) => request('put', url, body);
export const del = (url, body = null) => request('delete', url, body);
